/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Line item matches grouped by status
 * @export
 * @interface ComparisonStatisticsLineItemMatchesByStatus
 */
export interface ComparisonStatisticsLineItemMatchesByStatus {
    /**
     * 
     * @type {number}
     * @memberof ComparisonStatisticsLineItemMatchesByStatus
     */
    aiSuggested?: number;
    /**
     * 
     * @type {number}
     * @memberof ComparisonStatisticsLineItemMatchesByStatus
     */
    userConfirmed?: number;
    /**
     * 
     * @type {number}
     * @memberof ComparisonStatisticsLineItemMatchesByStatus
     */
    rejected?: number;
}

/**
 * Check if a given object implements the ComparisonStatisticsLineItemMatchesByStatus interface.
 */
export function instanceOfComparisonStatisticsLineItemMatchesByStatus(value: object): value is ComparisonStatisticsLineItemMatchesByStatus {
    return true;
}

export function ComparisonStatisticsLineItemMatchesByStatusFromJSON(json: any): ComparisonStatisticsLineItemMatchesByStatus {
    return ComparisonStatisticsLineItemMatchesByStatusFromJSONTyped(json, false);
}

export function ComparisonStatisticsLineItemMatchesByStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComparisonStatisticsLineItemMatchesByStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'aiSuggested': json['aiSuggested'] == null ? undefined : json['aiSuggested'],
        'userConfirmed': json['userConfirmed'] == null ? undefined : json['userConfirmed'],
        'rejected': json['rejected'] == null ? undefined : json['rejected'],
    };
}

export function ComparisonStatisticsLineItemMatchesByStatusToJSON(json: any): ComparisonStatisticsLineItemMatchesByStatus {
    return ComparisonStatisticsLineItemMatchesByStatusToJSONTyped(json, false);
}

export function ComparisonStatisticsLineItemMatchesByStatusToJSONTyped(value?: ComparisonStatisticsLineItemMatchesByStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aiSuggested': value['aiSuggested'],
        'userConfirmed': value['userConfirmed'],
        'rejected': value['rejected'],
    };
}

